import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import './SettingsContent.scss';
import { toastr } from 'react-redux-toastr';
import { isEmail } from '../../../util/utils';

export default (props) => {
  const { bot, updateBotRequest, user } = props;

  const { i18n } = useTranslation();

  const [host, setHost] = useState(
    bot.settings && bot.settings.email ? bot.settings.email.host || '' : ''
  );
  const [port, setPort] = useState(
    bot.settings && bot.settings.email ? bot.settings.email.port || '' : ''
  );
  const [username, setUsername] = useState(
    bot.settings && bot.settings.email ? bot.settings.email.username || '' : ''
  );
  const [password, setPassword] = useState(
    bot.settings && bot.settings.email ? bot.settings.email.password || '' : ''
  );

  const updateBot = () => {
    if (!isEmail(username)) {
      toastr.error('Erro', 'Usuário precisa ser um endereço de e-mail.');
    } else if (password === '') {
      toastr.error('Erro', 'Senha inválida');
    } else if (bot) {
      if (!bot.settings) {
        bot.settings = {};
      }
      bot.settings.email = {
        host: host,
        port: port,
        username: username,
        password: password,
      };
      updateBotRequest(bot._id, { settings: bot.settings });
    }
  };

  return (
    <div className="">
      <div className="title">
        {i18n.t('Configuração de Criador ')}
        <strong>{i18n.t('SMTP')}</strong>
      </div>
      <div className="subtitle mt-2">
        {i18n.t(
          'Configure o comportamento do bloco "Email" no background do seu bot'
        )}
      </div>
      <div className="form-group mt-3">
        <label>{i18n.t('Host')}:</label>
        <input
          disabled={user?.selectedCompany?.claim?.name === 'Viewer'}
          className="form-control"
          type="string"
          placeholder={i18n.t('smtp.exemplo.com')}
          value={host}
          onChange={(e) => setHost(e.target.value)}
        />
      </div>
      <div className="form-group">
        <label>{i18n.t('Porta')}:</label>
        <input
          disabled={user?.selectedCompany?.claim?.name === 'Viewer'}
          className="form-control"
          type="number"
          placeholder={i18n.t('564')}
          value={port}
          onChange={(e) => setPort(e.target.value)}
        />
      </div>
      <div className="form-group">
        <label>{i18n.t('Usuário')}:</label>
        <input
          disabled={user?.selectedCompany?.claim?.name === 'Viewer'}
          className="form-control"
          type="email"
          placeholder={i18n.t('usuario@empresa.com.br')}
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
      </div>
      <div className="form-group">
        <label>{i18n.t('Senha')}:</label>
        <input
          disabled={user?.selectedCompany?.claim?.name === 'Viewer'}
          className="form-control"
          type="password"
          placeholder="*********"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
      </div>
      <div>
        <button
          type="button"
          disabled={user?.selectedCompany?.claim?.name === 'Viewer'}
          className="btn btn-primary"
          onClick={updateBot}
        >
          {i18n.t('salvar')}
        </button>
      </div>
    </div>
  );
};
